<template>
  <div>
    <div class="page-header">
      <span class="h3">All {{ $t("tags.plural") }}</span>
      <router-link :to="$t('tags.archived_route')"><span class="h6 text-muted float-right">{{ $t("tags.singular") }} Archive</span></router-link>
    </div>

    <ul class="mt-2 list-group">
      <draggable v-model="allTags" @start="drag=true" @end="drag=false" handle=".sort-handle">
        <transition-group type="transition" :name="'flip-list'">
          <li v-for="tag in allTags" :key="tag.id" class="list-group-item">
            <div class='float-right d-flex align-items-center'>
              <i class="material-icons pointer ml-1 sort-handle">reorder</i>
            </div>
            <TagTitle :tag=tag />
          </li>
        </transition-group>
      </draggable>
    </ul>
  </div>
</template>

<script>
var firstBy = require('thenby');
import api from "api";
import QuickTask from "components/QuickTask";
import TagTitle from "components/TagTitle";
import NewQuickTask from "components/NewQuickTask";
import draggable from 'vuedraggable'

export default {
  components: {
    QuickTask,
    NewQuickTask,
    TagTitle,
    draggable
  },
  computed: {
    allTags: {
      set: function(value){
        var ordered_ids = []
        value.forEach(function(item, index){
          ordered_ids.push(item.id)
        })

        var payload = {
          name: 'tags',
          ordered_ids: ordered_ids
        }
        store.commit('updateSortedGroup', payload)

        return value;

      },
      get: function(){
        return store.getters.sortedActiveTags
      }
    }
  },
};
</script>
